export { ResponseSection, type ResponseSectionProps } from './ResponseSection';
